h1{text-align:center}p{font-size:13px}.form-group{margin-bottom:20px}.form-group .icon{cursor:pointer;font-size:1rem;right:10px;top:34px}.btn{width:100%}
/*# sourceMappingURL=login-form.component-EWNCOBIP.css.map */
